import React, { useState } from "react";
import Typical from "react-typical";
import axios from "axios";
import { toast } from "react-toastify";

import imgBack from "../../../src/images/mailz.jpeg";
import load1 from "../../../src/images/load2.gif";
import ScreenHeading from "../../utilities/ScreenHeading/ScreenHeading";
import ScrollService from "../../utilities/ScrollService";
import Animations from "../../utilities/Animations";
import "./ContactMe.css";

export default function ContactMe(props) {
  let fadeInScreenHandler = (screen) => {
    if (screen.fadeScreen !== props.id) return;
    Animations.animations.fadeInScreen(props.id);
  };

  const fadeInSubscription =
    ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [banner, setBanner] = useState("");
  const [bool, setBool] = useState(false);

  const handleName = (e) => {
    setName(e.target.value);
  };
  const handleEmail = (e) => {
    setEmail(e.target.value);
  };
  const handleMessage = (e) => {
    setMessage(e.target.value);
  };
  console.log(name);

  const submitForm = async (e) => {
    e.preventDefault();
    try {
      let data = {
        name,
        email,
        message,
      };
      setBool(true);
      const res = await axios.post(`/contact`, data);
      if (name.length === 0 || email.length === 0 || message.length === 0) {
        setBanner(res.data.msg);
        toast.error(res.data.msg);
        setBool(false);
      } else if (res.status === 200) {
        setBanner(res.data.msg);
        toast.success(res.data.msg);
        setBool(false);

        setName("");
        setEmail("");
        setMessage("");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const submitData = () => {
    setBool(true);
    setTimeout(() => {
      setBool(false);
    }, 5000)
  }

  return (
    <div className="main-container" id={props.id || ""}>
      <ScreenHeading subHeading={"Lets Keep In Touch"} title={"Contact Me"} />
      <section id="contact" className="contact">
        <div className="" data-aos="fade-up" style={{padding : "0 20px"}}>
          <div style={{display : "flex", justifyContent : "center", alignItems : "center"}}>
            
          </div>
          <div className="row">
            <div className="col-lg-5 d-flex align-items-stretch">
              <div className="info">
                <div className="address">
                  <i class='bx bx-current-location' ></i>
                  <h4>Location:</h4>
                  <p>SIDDHIVINAYAK JYOTISH KENDRA, Murgasol, Krishna Tower, Gurudwara road, Asansol, West Bengal - 713303, IN Opposite Bhikaram Sweets</p>
                </div>

                <div className="email">
                  <i className="bx bx-envelope"></i>
                  <h4>Email:</h4>
                  <p>arunpandey0401@gmail.com</p>
                </div>

                <div className="phone">
                  <i className="bx bx-phone"></i>
                  <h4>Call:</h4>
                  <p>9332283222</p>
                </div>

                <div className="phone">
                  <i className="bx bxl-whatsapp"></i>
                  <h4>Whatsapp :</h4>
                  <p>9332283222</p>
                </div>

                <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d752.2417157594568!2d86.99133236309233!3d23.67876031164422!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1675599746595!5m2!1sen!2sin" frameborder="0" style={{"border":0, width: "100%", height: "290px"}} allowfullscreen></iframe>
              </div>

            </div>

            {
              bool ? 
              <div className="col-lg-7 mt-5 mt-lg-0 d-flex server-d" style={{}}>
                 Sorry! Server is down <br></br>
                 Please whatsapp or call
              </div> : 
                <div className="col-lg-7 mt-5 mt-lg-0 d-flex align-items-stretch">
                <div className="php-email-form">
                  <div className="row">
                    <div className="form-group col-md-6">
                      <label for="name">Your Name</label>
                      <input type="text" name="name" className="form-control" id="name" required/>
                    </div>
                    <div className="form-group col-md-6">
                      <label for="name">Your Email</label>
                      <input type="email" className="form-control" name="email" id="email" required/>
                    </div>
                  </div>
                  <div className="form-group">
                    <label for="name">Subject</label>
                    <input type="text" className="form-control" name="subject" id="subject" required/>
                  </div>
                  <div className="form-group">
                    <label for="name">Message</label>
                    <textarea className="form-control" name="message" rows="10" required></textarea>
                  </div>
                  <div className="my-3">
                    <div className="loading">Loading</div>
                    <div className="error-message"></div>
                    <div className="sent-message">Your message has been sent. Thank you!</div>
                  </div>
                  <div className="text-center"><button type="submit" onClick={submitData}>Send Message</button></div>
                </div>
              </div>
            }

          </div>
        </div>
      </section>
      <footer id="footer">
        <div className="footer-top">
          <div className="container">
            <div className="row">

              <div className="col-lg-3 col-md-6 footer-contact">
                <h3>SIDDHIVINAYAK JYOTISH KENDRA</h3>
                <p>
                  Murgasol, Krishna Tower, <br></br>Gurudwara road, IN Opposite Bhikaram Sweets <br></br>Asansol, West Bengal - 713303, <br></br>
                  <br></br>
                  <strong>Phone:</strong>9332283222<br/>
                  <strong>Email:</strong> arunpandey0401@gmail.com<br/>
                </p>
              </div>

              <div className="col-lg-3 col-md-6 footer-links">
                <h4>Operation houurs at center</h4>
                <ul>
                  <li> Monday : - Closed</li>
                  <li> Tuesday : - Closed</li>
                  <li> Wednesday : - 5:00 PM - 9:00PM</li>
                  <li> Thursday : - 5:00 PM - 9:00PM</li>
                  <li> Friday : - 5:00 PM - 9:00PM</li>
                  <li> Saturday : - 5:00 PM - 9:00PM</li>
                  <li> Sunday : - 5:00 PM - 9:00PM</li>
                </ul>
              </div>

              <div className="col-lg-2 col-md-6 footer-links">
                <h4>Useful Links</h4>
                <ul>
                  <li><i className="bx bx-chevron-right"></i> <a href="#Home">Home</a></li>
                  <li><i className="bx bx-chevron-right"></i> <a href="#AboutMe">About Me</a></li>
                  <li><i className="bx bx-chevron-right"></i> <a href="#Service">Services</a></li>
                  <li><i className="bx bx-chevron-right"></i> <a href="#ContactMe">Contact us</a></li>
                </ul>
              </div>

              <div className="col-lg-2 col-md-6 footer-links">
                <h4>Our Services</h4>
                <ul>
                  
                  <li><i className="bx bx-chevron-right"></i> Vastu Consultant</li>
                  <li><i className="bx bx-chevron-right"></i> Palm Reading</li>
                  <li><i className="bx bx-chevron-right"></i> Business Astrology</li>
                  <li><i className="bx bx-chevron-right"></i> Wealth Astrology</li>
                  <li><i className="bx bx-chevron-right"></i> Medical Astrology</li>
                </ul>
              </div>

              <div className="col-lg-2 col-md-6 footer-links">
                <h4></h4>
                <ul>
                  <li><i className="bx bx-chevron-right"></i> Kundali Prediction</li>
                  <li><i className="bx bx-chevron-right"></i> Kundali Matching</li>
                  <li><i className="bx bx-chevron-right"></i> Career & Job</li>
                  <li><i className="bx bx-chevron-right"></i> Finance & Business</li>
                  <li><i className="bx bx-chevron-right"></i> Marital Life</li>
                </ul>
              </div>

            { /*
            <div className="col-lg-3 col-md-6 footer-links">
                <h4>Our Social Networks</h4>
                <div className="social-links mt-3">
                  <a href="#" className="twitter"><i className="bx bxl-twitter"></i></a>
                  <a href="#" className="facebook"><i className="bx bxl-facebook"></i></a>
                  <a href="#" className="instagram"><i className="bx bxl-instagram"></i></a>
                  <a href="#" className="google-plus"><i className="bx bxl-skype"></i></a>
                  <a href="#" className="linkedin"><i className="bx bxl-linkedin"></i></a>
                </div>
              </div>
            
            */ }
              

            </div>
          </div>
        </div>

        <div className="container footer-bottom clearfix">
          <div className="copyright">
            &copy; Copyright <strong><span>AcharyaArunPandey</span></strong>. All Rights Reserved
          </div>
          <div className="credits">
            Designed by <a href="https://barunpandey.netlify.app/">Barun Pandey</a>
          </div>
        </div>
      </footer>
    </div>
  );
}
